// extracted by mini-css-extract-plugin
module.exports = {"small-pin":"_2787e5dfdf--small-pin--IpfYl","large-pin":"_2787e5dfdf--large-pin--HseAI","icon":"_2787e5dfdf--icon--X3uaq"};